<ion-app>
  <ion-router-outlet id="main-content"></ion-router-outlet>
  @if (isLoggedIn) {
    <ion-menu 
    side="end" 
    menuId="app-menu" 
    contentId="main-content" 
    type="overlay"
    [swipeGesture]="isUserSide"
    (ionWillOpen)="setOpen(true)" 
    (ionDidClose)="setOpen(false)"
  >
    @if(isMenuOpen) {
      <app-menu></app-menu>
    }
  </ion-menu>

  <ion-menu 
    side="end" 
    menuId="charity-menu" 
    contentId="main-content" 
    type="overlay"
    [swipeGesture]="!isUserSide"
    (ionWillOpen)="setCharityOpen(true)" 
    (ionDidClose)="setCharityOpen(false)"
  >
    @if(isCharityMenuOpen) {
      <app-charity-menu></app-charity-menu>
    }
  </ion-menu>

  <ion-menu 
    side="end" 
    menuId="business-menu" 
    contentId="main-content" 
    type="overlay"
    [swipeGesture]="!isUserSide"
    (ionWillOpen)="setBusinessOpen(true)" 
    (ionDidClose)="setBusinessOpen(false)"
  >
    @if(isBusinessMenuOpen) {
      <app-business-menu></app-business-menu>
    }
  </ion-menu>
  }
  
</ion-app>
